export default __webpack_public_path__ + "static/media/d_wdt_c_1_2.f7197371.mp3";